<div class="uk-grid">
  <div class="uk-width-1-3@s">
    <div class="uk-card uk-card-default list-button ">
      <button
        #formation
        (click)="gotToFormation($event)"
        [ngClass]="displayFormation ? 'button-menu-primary' : ''"
        class="uk-button-radio uk-button-default uk-button-large k-text-uppercase k-button-outline"
      >
        Formations
      </button>
      <button
        [ngClass]="displayPlanning ? 'button-menu-primary' : ''"
        (click)="gotToPlanning($event)"
        class="uk-button-radio uk-button-default uk-button-large k-text-uppercase k-button-outline"
      >
        Planning
      </button>
      <button
        [ngClass]="displayApprenant ? 'button-menu-primary' : ''"
        (click)="gotToApprenant($event)"
        class="uk-button-radio uk-button-default uk-button-large k-text-uppercase k-button-outline"
      >
        Apprennant(s)
      </button>
      <button
        [ngClass]="displayDoc ? 'button-menu-primary' : ''"
        (click)="goToDoc($event)"
        class="uk-button uk-button-default uk-button-large k-text-uppercase k-button-outline"
      >
        Document(s)
      </button>
    </div>
  </div>
  <div class="uk-width-3-5@s">
    <ags-formation-info *ngIf="displayFormation"></ags-formation-info>
    <ags-formation-planning [idFormation]="idFormation" *ngIf="displayPlanning"></ags-formation-planning>
    <ags-formation-apprenant [idFormation]="idFormation" *ngIf="displayApprenant"></ags-formation-apprenant>
    <ags-formation-doc *ngIf="displayDoc"></ags-formation-doc>
  </div>
</div>
